import { FPRO_US, SITE_SECTION } from './analyticsConstants';

export const defaultDigitalData = {
    page: {
        pageName: '',
        siteSection: SITE_SECTION,
        hierarchy: '',
        userLanguage: 'eng',
        client: FPRO_US,
        country: FPRO_US,
        site: 'pro.ford.com',
        pageNameNoVehicle: '',
        tool: '',
        toolDescriptor: '',
        radUIVersion: '',
    },
    onclick: {
        onclick: '',
        onclickLinkName: '',
        referredTo: '',
    },
    event: {
        action: '',
    },
    user: {
        paCode: '',
        fordRegion: '',
        fdafCode: '',
        leadType: '',
        leadOptIn: '',
        loginStatus: '',
        optInStatus: '',
    },
};
